export default __webpack_public_path__ + "94e95fe36bac1265605fe04e7bd3de06.svg";